import type { ReadonlyDeep } from '../../types/readonly-deep';
import type { TTrajectoryMeasure } from '../../types/trajectory';

const EMPTY = '—';

export function formatTrajectoryMeasure(measure?: ReadonlyDeep<TTrajectoryMeasure> | null): string {
  if (!measure || measure.value === undefined || measure.value === null) {
    return EMPTY;
  }

  const uom = measure.uom?.trim();

  if (!uom) {
    return String(measure.value);
  }

  if (uom === 'dega' || uom === 'deg' || uom === '°') {
    return `${measure.value}°`;
  }

  return `${measure.value} ${uom}`;
}

export function formatTrajectoryText(value?: string | number | null): string {
  if (value === undefined || value === null || value === '') {
    return EMPTY;
  }

  return String(value);
}
